import type { UsuarioLinha } from '@triade/contracts';
import { SituacaoUsuarioBadge } from './situacao-badge';
import { rotuloAcesso, situacaoUsuario } from './tipos';

export interface UsuariosTabelaProps {
  usuarios: UsuarioLinha[];
  selecionadoId: string | undefined;
  onAbrir: (u: UsuarioLinha) => void;
}

const MAX_CHIPS = 3;

/** Grade de usuarios: nome, e-mail, acessos e situacao. Clicar numa linha abre o formulario do usuario. */
export function UsuariosTabela({ usuarios, selecionadoId, onAbrir }: UsuariosTabelaProps) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full min-w-[760px] border-collapse text-small">
        <thead>
          <tr className="text-left text-caption text-ink-muted">
            <th scope="col" aria-sort="ascending" className="px-4 py-2.5 font-medium">Nome</th>
            <th scope="col" className="px-3 py-2.5 font-medium">E-mail</th>
            <th scope="col" className="px-3 py-2.5 font-medium">Acessos</th>
            <th scope="col" className="px-4 py-2.5 font-medium">Situação</th>
          </tr>
        </thead>
        <tbody>
          {usuarios.map((u) => (
            <tr
              key={u.id}
              data-testid="linha-usuario"
              aria-selected={u.id === selecionadoId}
              onClick={() => onAbrir(u)}
              className={`cursor-pointer border-t border-line-soft hover:bg-surface-muted ${u.id === selecionadoId ? 'bg-line-soft' : ''}`}
            >
              <td className="px-4 py-3">
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    onAbrir(u);
                  }}
                  className="text-left font-semibold text-ink hover:underline"
                >
                  {u.nome}
                </button>
                {u.ehVoce && <span className="ml-2 text-caption text-ink-muted">(você)</span>}
              </td>
              <td className="px-3 py-3 text-ink-secondary">{u.email}</td>
              <td className="px-3 py-3">
                <ul className="flex flex-wrap gap-1.5">
                  {u.acessos.slice(0, MAX_CHIPS).map((a) => (
                    <li key={a.id} className="rounded-full bg-line-soft px-2 py-0.5 text-caption text-ink-body">
                      {rotuloAcesso(a)}
                    </li>
                  ))}
                  {u.acessos.length > MAX_CHIPS && <li className="px-1 text-caption text-ink-muted">+{u.acessos.length - MAX_CHIPS}</li>}
                  {u.acessos.length === 0 && <li className="text-caption text-ink-muted">{u.acessosForaDoEscopo > 0 ? 'Fora da sua empresa' : 'Sem acesso'}</li>}
                </ul>
              </td>
              <td className="px-4 py-3">
                <SituacaoUsuarioBadge situacao={situacaoUsuario(u)} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
